import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  appBar: {
    boxShadow: theme.shadows[4],
  },
}));

export default useStyles;
